module.exports = __webpack_public_path__ + "img/S4.d7fb54a3.png";